module.exports = "/templates/bds/public/images/676227963907c0436cc9e465489a38d6.png";